import { Box, TextField, TextFieldProps, Typography } from '@mui/material';

export default function Input(props: TextFieldProps) {

    const { name, label, value, size, onChange,...other } = props;
    return (
        <Box display={"flex"} sx={{width:'60%'}}>
            <Typography fontWeight={600} padding={"8px 10px 0px 0"}> {label}</Typography>
            <TextField
                variant="outlined"
                // label={label}
                name={name}
                value={value}
                size={size || 'small'}
                onChange={onChange}
                {...other}
            // {...(error && {error:true,helperText:error})}
            />
        </Box>
    )
}
